import { createTheme } from '@mui/material'

export const globalTheme = createTheme({
  typography: {
    allVariants: {
      letterSpacing: 'inherit',
    },
  },
})
